import React from 'react';
import { Navigate } from 'react-router-dom';
import { setRedirectUrl, getCurrentUrl } from '../utils/authRedirect';

const AuthRedirect = ({ user, children }) => {
  if (!user) {
    // Store the current URL for redirect after login
    setRedirectUrl(getCurrentUrl());
    // Redirect to login with the current URL as redirect parameter
    return <Navigate to={`/login?redirect=${encodeURIComponent(getCurrentUrl())}`} />;
  }
  
  return children;
};

export default AuthRedirect; 